<template>
    <div>
        <card-header title="Completed Quotes" icon="fa-file-check"/>

        <card-body>
            <card-list>
                <quote-tile
                    v-for="quote in quotes"
                    :card="card"
                    :quote="quote"
                />
            </card-list>
            <infinite-loading @infinite="loadQuotes">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </card-body>

        <card-footer>
            <strong>Total Completed:</strong> {{quotes.length}} of {{paging.total}}
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import QuoteTile from "@/components/tiles/QuoteTile";

    import {client as http} from '../../http_client';
    import {mapGetters} from "vuex";
    import CardFooter from "../../TIER/components/CardFooter";

    export default {
        components: {CardFooter, QuoteTile, CardHeader, CardBody, CardToolbar, CardList, SubheaderListItem},
        props: ['card', 'child'],
        data() {
            return {
                quotes: [],
                paging: {
                    start: 0,
                    count: 30,
                    total: 0
                }
            }
        },
        methods: {
            loadQuotes: function ($state) {

                http.get(`quotes/complete/${this.paging.start}/${this.paging.count}`, {force: true}).then(response => {
                    this.quotes.push(...response.data.quotes);
                    this.paging.start += response.data.quotes.length;
                    this.paging.total = response.data.total;

                    if ($state) {
                        if (response.data.total === this.quotes.length) {
                            console.log('complete!');
                            $state.complete();
                        } else {
                            $state.loaded();
                        }
                    }

                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function () {
                this.$emit('loading', true);
                this.loadQuotes();
            }
        },
        mounted: function () {
            this.$emit('loading', true);
            this.loadQuotes();
        }
    }
</script>
